import React from 'react'

function StatusPill(props) {

    const {text, status} = props

    var color = "#6c757d"
    var textColor = "black"

    switch (status) {
    case "green":
        color = "#dae8cc"
        break
    case "yellow":
        color = "#fbeeca"
        break
    case "red":
        color = "#db7f6d"
        break
    case "blue":
        color = "#d6ecff"
        textColor = "#4289FF"
        break
    }

    return (
        <div className={"d-flex d-row" + props.className}>
            <span 
            className={"py-1 px-2 my-auto"}
            style={{
                    backgroundColor: color,
                    color: textColor,
                    borderRadius: "4px"
                }}
            >
                {text}
            </span>
        </div>
    )
}

export default StatusPill